import * as React from "react";
import { isPermitted } from "util/PermissionsMixin";
import usePluginEntities from "hooks/usePluginEntities";
import useEventById from "hooks/useEventById";
import useEventDefinition from "components/events/events/hooks/useEventDefinition";
import { Spinner } from "components/common";
import DefaultDetails from "views/components/widgets/events/EventsList/DefaultDetails";
import useCurrentUser from "hooks/useCurrentUser";
export const usePluggableEventDetails = (eventId) => {
  const pluggableEventDetails = usePluginEntities("views.components.widgets.events.detailsComponent");
  return pluggableEventDetails.filter((perspective) => perspective.useCondition ? !!perspective.useCondition() : true).map(({ component: PluggableEventAction, key }) => /* @__PURE__ */ React.createElement(PluggableEventAction, { key, eventId }));
};
export const DefaultDetailsWrapper = ({ eventId }) => {
  const { data: event, isLoading } = useEventById(eventId);
  const currentUser = useCurrentUser();
  const canViewDefinition = isPermitted(currentUser.permissions, `eventdefinitions:read:${event == null ? void 0 : event.event_definition_id}`);
  const { data: eventDefinition, isFetching } = useEventDefinition(event == null ? void 0 : event.event_definition_id, canViewDefinition);
  if (isFetching) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(DefaultDetails, { event, eventDefinitionContext: eventDefinition });
};
const EventDetailsWrapper = ({ eventId }) => {
  const puggableEventDetails = usePluggableEventDetails(eventId);
  if (puggableEventDetails == null ? void 0 : puggableEventDetails.length) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, puggableEventDetails);
  }
  return /* @__PURE__ */ React.createElement(DefaultDetailsWrapper, { eventId });
};
export default EventDetailsWrapper;
